module.exports = __webpack_public_path__ + "assets/img/taobao.1a9b3461.png";